// extracted by mini-css-extract-plugin
export default {"reuseNote":"ExtractionReuseWarning_reuseNote__wvfyI"};